import {Logger} from '../Utils/Logger';
import {ArgValidator} from '../Utils/ArgValidator';
import {StringUtils} from "../Utils";

export class EngineComponentFactory {
    private static list = {};
    private static count = 0;

    public static register(component: any, componentType: string): void {
        var cmpName = component.name;
        if (cmpName === undefined || cmpName === '') {
            throw new Error('[EngineComponentFactory] specified component does not contain property "name"');
        }

        if (componentType === undefined || componentType === '') {
            throw new Error('[EngineComponentFactory] component type was not specified!');
        }

        var list = EngineComponentFactory.list;
        var reg = list[cmpName];
        if (!reg) {
            list[cmpName] = {
                component: component,
                type: componentType
            };

            this.count++;
            Logger.debugGroup('Register engine component', `Engine Component '${cmpName}' (type: ${componentType})`
                +` was successfully registered (${this.count} so far).`);
        } else {
            throw new Error(`[EngineComponentFactory] Engine Component "${cmpName}" (type: ${componentType})`
                +` is already registered!`);
        }
    }

    public static getComponentName(component: any): string {
        ArgValidator.ensureIsNotNullOrUndefined(component, 'component');

        var result = component.__componentName__;
        if (StringUtils.isNullOrEmpty(result)) {
            result = component.toString();
        }

        return result;
    }

    public static isTypeOf(typeName: string, requiredComponentType: string): boolean {
        ArgValidator.ensureStringIsNotNullOrEmpty(typeName, 'typeName');
        ArgValidator.ensureStringIsNotNullOrEmpty(requiredComponentType, 'requiredComponentType');

        var list = EngineComponentFactory.list;
        var reg = list[typeName] as any;
        if (reg) {
            return reg.type === requiredComponentType;
        }

        throw new Error(`[EngineComponentFactory] "isTypeOf", could not found engine component "${typeName}"!`);
    }

    public static get<T>(typeName: string): T {
        ArgValidator.ensureStringIsNotNullOrEmpty(typeName, 'typeName');

        var list = EngineComponentFactory.list;
        var reg = list[typeName] as any;
        if (reg) {
            var type: any = reg.component as T;
            return new type();
        }

        throw new Error(`[EngineComponentFactory] "get", could not found engine component "${typeName}"!`);
    }
}

/**
 * @decorator engineComponent - registers engine component
 * @param component - engine component to register
 */
export function engineComponent(componentType: string) {
    return function (component: any) {
        EngineComponentFactory.register(component, componentType);
        component.prototype.__componentName__ = component.name;
        component.prototype.__componentType__ = componentType;
    }
}

const isBrowser = typeof window !== 'undefined';
if (isBrowser) {
    var win = window as any;
    win['engineComponent'] = engineComponent;
}


/** WEBPACK FOOTER **
 ** ./Engine/Component/EngineComponentFactory.ts
 **/